export const queryKeyBuilder = {
  currentUser: () => ['currentUser'] as const,
  giftCardsStatuses: () => ['giftCardsStatuses'] as const,
  giftCardsProducts: () => ['giftCardsProducts'] as const,
  giftCardsToShow: (queryParams: unknown) => ['giftCards', queryParams] as const,
  giftCardsToExport: (queryParams: unknown) => ['exportedGiftCards', queryParams] as const,
};
